import {toast} from "react-toastify";

export default function handelApiSuccessMessage(res, notify = true) {
    let message = 'ok'
    if (res?.response?.message) {
        message = res?.message
    }

    if(res?.message) {
        message = res?.message
    }

    if(res?.data?.message) {
        message = res?.data?.message
    }

    if(res?.data?.data?.message) {
        message = res?.data?.data?.message
    }

    if (notify)
    {
        toast.success(message)
    }
}
